import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';

export const VIS_MS_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => VisMultiselectComponent),
  multi: true
};
@Component({
  selector: 'app-vis-multiselect',
  templateUrl: './vis-multiselect.component.html',
  styleUrls: ['./vis-multiselect.component.css'],
  providers: [VIS_MS_CONTROL_VALUE_ACCESSOR]
})
export class VisMultiselectComponent implements OnInit, ControlValueAccessor {
  @Input()
  data: { text: string, value: any }[];
  @Input()
  allowCustom: Boolean;
  @Input()
  filterable: Boolean;
  @Input()
  textField: string;
  @Input()
  valueField: string;
  @Input()
  valuePrimitive: Boolean;
  // @Output()
  // filterChange: EventEmitter<any> =new EventEmitter(false);

  @Output()
  valueChange: EventEmitter<any> = new EventEmitter(false);

  @ViewChild(MatSelect, { static: true })
  matSelect: MatSelect;

  _currentValue: any;
  _onChange: (value) => {};
  _onTouched: () => {};
  _disabled: boolean;

  _class: string;
  constructor(private elementRef: ElementRef) {
  }

  ngAfterContentChecked() {

    this._class = this.elementRef.nativeElement.className;
  }



  writeValue(obj: any): void {
    if (obj) {
      this._currentValue = obj;
    }
  }
  registerOnChange(fn: any): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  ngOnInit(): void {
    // mat-select 以 trigger 字級 × 3em 推算選項高度，用於點選時將 active option 捲入可視範圍；
    // 全域 .mat-option 高度固定 24px（styles.scss），推算值與實際不符會使面板捲到錯誤位置。
    // 面板開啟時以實際渲染的選項高度為準，未渲染（offsetHeight 為 0）時沿用 Material 原算法。
    // 依賴 Material 10.2 私有方法 _getItemHeight，升級 Material 時須確認此方法仍存在。
    const select = this.matSelect as any;
    const defaultGetItemHeight = select._getItemHeight.bind(select);
    select._getItemHeight = () => {
      const first = this.matSelect.options && this.matSelect.options.first;
      const height = first ? first._getHostElement().offsetHeight : 0;
      return height > 0 ? height : defaultGetItemHeight();
    };
  }


  _valueChange(evt: MatSelectChange) {
    this._currentValue = evt.value;
    if (this._onChange) {
      this._onChange(evt.value)
    }
    setTimeout(() => {
      if (this.valuePrimitive) {
        this.valueChange.emit(evt.value);
      } else {
        var choseArray = (evt.value as Array<any>)
        var seletcedItems = this.data.filter(d => choseArray.includes(d.value));
        this.valueChange.emit(seletcedItems);
      }
    },0)
  }
}
